import { render, staticRenderFns } from "./LmSettings.vue?vue&type=template&id=4616a966&"
import script from "./LmSettings.vue?vue&type=script&lang=js&"
export * from "./LmSettings.vue?vue&type=script&lang=js&"
import style0 from "./LmSettings.vue?vue&type=style&index=0&id=4616a966&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports